import "./rolling-number";
import { header } from "./widgets/header";
import { hero } from "./widgets/hero";
import { teamMembers } from "./widgets/team-members";
import { videoDialog } from "./widgets/video-callout";
import { shufflingImages } from "./widgets/shuffling-images";
import { statCards } from "./widgets/stat-cards";
import { story } from "./widgets/story";
import { popup } from "./widgets/popup";
import { carousel } from "./widgets/carousel"
import { Animate } from "./widgets/animate";
import { portfolioLogos } from "./widgets/portfolio-logos";
import { portfolio } from "./widgets/portfolio";
import { portfolioCards } from "./widgets/portfolio-cards";
import { coreValues } from './widgets/core-values';
import { imageCards } from './widgets/image-cards';
import { createFocusTrap } from './widgets/focus-trap';

const widgets = () => {
    header();
    hero();
    videoDialog();
    teamMembers();
    shufflingImages();
    statCards();
    story();
    portfolio();
    portfolioCards();
    carousel();
    portfolioLogos();
    popup();
    coreValues();
    imageCards();
};

const initAnimations = () => {
    const animate = new Animate();
    animate.animateStyle = 'fade-side';
    animate.animatePagesOnce = false;
    animate.animateComponents = '.animate';
    animate.abortCondition = '.is-editor';

    if (document.querySelector('.team-member-listing')) {
        animate.animateStyle = 'fade-up';
        animate.animationDelay = '1500';
    }

    animate.run();
};

const displayCookieBanner = () => {
    const isPrivacyPolicyPage = window.location.pathname === '/privacy-policy';

    if (!isPrivacyPolicyPage) {
        const manager = window.TrackingConsentManager;
        if (!manager) return;
        let trap;
        let previousFocus;

        const focusBanner = () => {
            if (trap?.active) return;
            const banner = document.querySelector('#tracking-consent-dialog');
            if (!banner?.getClientRects().length) return;

            previousFocus = document.activeElement === document.body
                ? null : document.activeElement;
            banner.setAttribute('role', 'dialog');
            trap = createFocusTrap(banner);
            trap.activate();
            banner.querySelector('a[href], button:not(:disabled)')?.focus({ preventScroll: true });
        };
        manager.addEventListener('AfterDialogDisplayed', focusBanner);
        manager.addEventListener('BeforeDialogClosed', () => {
            if (!trap?.active) return;
            trap.release();
            previousFocus?.focus({ preventScroll: true });
        });
        focusBanner();
        return;
    }

    const interval = setInterval(() => {
        const cookieBanner = document.querySelector('#tracking-consent-dialog.cookie-banner');
        const cookieOverlay = document.querySelector('.cookie-overlay');
        const consentGiven = document.cookie.includes('sf-tracking-consent=true') || 
                             document.cookie.includes('sf-tracking-consent="true"');

        if (cookieBanner && cookieOverlay && !consentGiven) {

            cookieBanner.style.display = 'none';
            cookieOverlay.style.display = 'none';
            cookieOverlay.classList.remove('cookie-overlay');
            clearInterval(interval);
        }
    }, 300);


    setTimeout(() => clearInterval(interval), 5000);
};

const footerLinkImg = () => {
    const footerlinks = document.querySelectorAll('.footer .footer__lower-section .nav-item');
    const targetLink = Array.from(footerlinks).find(link => link.textContent.trim() === 'Your Privacy Choices');

    if (targetLink) {
        targetLink.classList.add('icon');
    }
};

const marqueeAnimation = () => {
    const marquees = document.querySelectorAll('.marquee');
    if(!window.matchMedia("(perfers-reduced-motion: reduce)").matches) {
        addAnimation();
    }

    function addAnimation() {
        marquees.forEach(marquee => {
            marquee.setAttribute('data-animated', true);

            const marqueeInner = marquee.querySelector('.marquee-inner');
            const marqueeContent = Array.from(marqueeInner.children);

            marqueeContent.forEach(item => {
                const duplicatedItem = item.cloneNode(true);
                duplicatedItem.setAttribute('aria-hidden', 'true');
                marqueeInner.appendChild(duplicatedItem);
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    widgets();
    initAnimations();
    footerLinkImg();
    displayCookieBanner();
    marqueeAnimation();
});

